"use strict";import{IconShowMenu as e}from"../src/elements/IconShowMenu.js";import{defineElement as o}from"@spectrum-web-components/base/src/define-element.js";o("sp-icon-show-menu",e);
//# sourceMappingURL=sp-icon-show-menu.js.map
